import LocationObject from 'entities/locationObject/model';

import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SAVE,
  SAVE_SUCCESS,
  SAVE_FAILED,
  REQUEST_ADDRESS_CHANGE,
  CLEAR_ADDRESS_CHANGE,
} from './constants';

export const initAction = () => ({
  type: INIT,
});
export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});
export const initFailedAction = (error: string, errorCode?: string) => ({
  type: INIT_FAILED,
  error,
  errorCode,
});

export const saveAction = (data: unknown, FORM_IDENTIFIER: string) => ({
  type: SAVE,
  data,
  FORM_IDENTIFIER,
});
export const saveSuccessAction = () => ({
  type: SAVE_SUCCESS,
});
export const saveFailedAction = (
  error: string,
  errorCode: string,
  additional?: Record<string, unknown>
) => ({
  type: SAVE_FAILED,
  error,
  errorCode,
  ...additional,
});

export const requestAddressChangeAction = (newAddress: LocationObject) => ({
  type: REQUEST_ADDRESS_CHANGE,
  newAddress,
});
export const clearAddressChangeAction = () => ({
  type: CLEAR_ADDRESS_CHANGE,
});
